<script setup lang="ts">
import type { ItemWithKey } from "@/interfaces";
import {
  useSortable,
  moveArrayElement,
} from "@vueuse/integrations/useSortable";
import { computed, shallowRef, toRefs, useTemplateRef } from "vue";

interface Props {
  items: ItemWithKey[];
}

const props = defineProps<Props>();

const { items } = toRefs(props);

const listContainerRef = useTemplateRef<HTMLElement>("listContainerRef");
const list = computed(() => shallowRef(items.value).value);

type OnUpdateEvent = {
  oldIndex: number;
  newIndex: number;
};

useSortable(listContainerRef, list.value, {
  animation: 300,
  onUpdate: (e: OnUpdateEvent) => {
    const newCards = items.value;
    moveArrayElement(newCards, e.oldIndex, e.newIndex);
  },
});
</script>

<template>
  <div class="flex flex-col gap-3" ref="listContainerRef">
    <div v-for="item of list" :key="item.key">
      <slot :item="item"></slot>
    </div>
  </div>
</template>
